// extracted by mini-css-extract-plugin
export default {"container":"BookingInfo_container__LiPur","title":"BookingInfo_title__Y+wYu"};